import template from './adpLink.html';
import controller from './adpLink.controller';
import './adpLink.less';

let adpLinkComponent = {
  restrict: 'E',
  bindings: {
    label: "@"
  },
  template,
  controller
};

export default adpLinkComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpLink/adpLink.component.js